var StatusArray;
var StatusIconArray;
var StatusIterator;
var currentTween;

$(document).ready(function () {
	
	
	StatusArray = [$("#Twitter"), $("#Facebook"), $("#LinkedIn"), $("#YouTube")];
	StatusIconArray = [$("#footerTwitter"), $("#footerFacebook"), $("#footerLinkedin"), $("#footerYoutube")];	
	StatusIterator = Math.floor(Math.random() * 4);
	
	
	
	StatusIconArray[StatusIterator].addClass("active");
	
	StatusArray[0].hide();
	StatusArray[1].hide();
	StatusArray[2].hide();
	StatusArray[3].hide();
	
	
	StatusArray[StatusIterator].show();
	
	$( "a[href*='facebook.com'][onmouseover^='LinkshimAsyncLink.swap']" ).each(function(index) {  
		var url = $(this).text();
		$(this).attr("href", url); 
		$(this).attr("onclick", url); 
		$(this).attr("onmouseover", url); 
	});
	
	var FacebookText = $("#Facebook .description").html();
	var SliceLocation = FacebookText.indexOf("<br><br>");
	
	/*if(SliceLocation != -1)	
		FacebookText = FacebookText.slice(0,SliceLocation);*/
	
	
	
	$("#Facebook .description").html(FacebookText);
	
	
	
	
	
	$("#footerBottomShare #footerArrowLeft").click(function(event) {
  		event.preventDefault();
		
		if(currentTween)
			currentTween.kill();
		
		StatusArray[StatusIterator].myShow(500);
		StatusIconArray[StatusIterator].removeClass("active");
		
		StatusIterator = StatusIterator-1;
		
		if(StatusIterator < 0)
				StatusIterator = 3;
		
		StatusArray[StatusIterator].myShow(1000);
		StatusIconArray[StatusIterator].addClass("active");
		
		
	});
	
	
	$("#footerBottomShare #footerArrowRight").click(function(event) {
  		event.preventDefault();
		
		if(currentTween)
			currentTween.kill();
		
		StatusArray[StatusIterator].myShow(500);
		StatusIconArray[StatusIterator].removeClass("active");
		
	
		StatusIterator = StatusIterator+1;
		
		if(StatusIterator > 3)
			StatusIterator = 0;
		
		StatusArray[StatusIterator].myShow(1000);
		StatusIconArray[StatusIterator].addClass("active");
		
		
	});
	
	
	function cycleComplete(){
		
		if(currentTween)
			currentTween.kill();
		
			
			StatusArray[StatusIterator].myShow(500);
			StatusIconArray[StatusIterator].removeClass("active");
		
			StatusIterator = StatusIterator+1;
		
			if(StatusIterator > 3)
				StatusIterator = 0;
			
			StatusArray[StatusIterator].myShow(1000);
			StatusIconArray[StatusIterator].addClass("active");
		
			
	}
	
	function linkify(inputText) {
	    var replaceText, replacePattern1, replacePattern2, replacePattern3;

    	//URLs starting with http://, https://, or ftp://
    	replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    	replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

    	//URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    	replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    	replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

    	//Change email addresses to mailto:: links.
    	replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
   		replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');
		
    	return replacedText
	}
	
	$("#LinkedIn .description").html(linkify( $("#LinkedIn .description").html() ));
	$("#Twitter .description").html(linkify( $("#Twitter .description").html() ));
	
	$.fn.myShow = function(duration) {
  		return this.animate({height: "toggle", opacity: "toggle"}, duration || 1000);
	};
	
	
});




